import React from "react";
import { BoxProps, Box } from "@mui/material";
const BoxKit: React.FC<BoxProps> = ({
  children,

  ...props
}) => {
  return <Box {...props}>{children}</Box>;
};

export default BoxKit;
